import type ErrorStatus from '$shared/constants/ErrorStatus';
import type ServiceError from '$shared/models/ServiceError';
import { AppException } from './AppException';

export class ApiException extends AppException {
  public readonly name: string;
  public readonly methodName: string;
  public readonly args: Record<string, unknown>;
  public readonly err: ServiceError;

  constructor(
    name: string,
    methodName: string,
    args: Record<string, unknown>,
    err: ServiceError,
    data: unknown,
    sendToSentry = true
  ) {
    super(err, data, sendToSentry);
    this.name = name;
    this.methodName = methodName;
    this.args = args;
    this.err = err;
  }

  public get title(): string {
    return this.err?.title || this.err?.message;
  }

  public get status(): ErrorStatus | undefined {
    return this.data?.status;
  }

  get extras(): any {
    return {
      type: 'API',
      service: this.name,
      methodName: this.methodName,
      args: this.args
    };
  }

  static from(
    name: string,
    methodName: string,
    args: Record<string, unknown>,
    err: unknown,
    data: unknown,
    sendToSentry = true
  ): ApiException {
    return new ApiException(name, methodName, args, err, data, sendToSentry);
  }
}
